import { css } from '@linaria/core';
import { baseTheme, theming } from 'styles/utils';
export const tooltipArrowStyled = "omponents__PlatformResourceSelector__Tooltip_styled_tsx-tooltipArrowStyled-tslw2pc";
export const tooltipWrapperStyled = "omponents__PlatformResourceSelector__Tooltip_styled_tsx-tooltipWrapperStyled-tz56hpb";
export const tooltipContentStyled = "omponents__PlatformResourceSelector__Tooltip_styled_tsx-tooltipContentStyled-t75ljne";

require("./Tooltip.styled.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Tooltip.styled.tsx");